const SIGN_IN_RETURN_KEY = 'vpSignInReturnTo';

export const rememberSignInReturn = (path: string) => {
  try {
    sessionStorage.setItem(SIGN_IN_RETURN_KEY, path);
  } catch {
    // Storage throws a SecurityError when site data is blocked; sign-in then just lands on '/'.
  }
};

export const takeSignInReturn = (): string | undefined => {
  try {
    const path = sessionStorage.getItem(SIGN_IN_RETURN_KEY) ?? undefined;
    sessionStorage.removeItem(SIGN_IN_RETURN_KEY);

    return path;
  } catch {
    // Blocked storage, as above: no remembered screen.
    return undefined;
  }
};
